import { useState, useEffect } from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useLanguage } from "@/contexts/LanguageContext";
import { SearchBarProps } from "./types";

export const SearchBar = ({ searchTerm, onSearchChange, placeholder }: SearchBarProps) => {
  const [localSearch, setLocalSearch] = useState(searchTerm);
  const { t } = useLanguage();

  useEffect(() => {
    const timer = setTimeout(() => {
      onSearchChange(localSearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [localSearch, onSearchChange]);

  return (
    <div className="relative w-full sm:w-auto">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
      <Input
        placeholder={placeholder || t("dashboard.products.filters.search")}
        value={localSearch}
        onChange={(e) => setLocalSearch(e.target.value)}
        className="pl-10 pr-8 w-full min-w-[180px] max-w-full sm:max-w-[220px] rounded-full bg-white/60 border-0 ring-1 ring-gray-200 focus-visible:ring-2 focus-visible:ring-teal-500"
      />
      {localSearch && (
        <button
          type="button"
          onClick={() => setLocalSearch("")}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-900"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
